export default __webpack_public_path__ + "static/media/Background_00251.f20a5fd6.png";